export default "__VITE_ASSET__mKN0Ve4m__"